// ----------------------------
// Created by Bulletproof Games
//            2021
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Game Controller
//
// The game controller tracks and looks after the current game state, and orchestrates components
// ----------------------------

gameController = {};
gameController.isPrePaid = false;
gameController.inFreeSpins = false;
gameController.cyclingWins = false;
gameController.spinComplete = false;
gameController.bonusSymbolsLanded = 0;
gameController.fireballsLanded = 0;
gameController.minBonusForFeature = 3; //should be data driven
gameController.minBonusForFeature2 = 8; //should be data driven
gameController.minBonusForFeature2Anticipation = 5; //should be data driven
gameController.slamStopped = false;
gameController.playSingleBonus = true;
gameController.preFSReelPrize = 0;
gameController.wildSymbolsToStandOut = [];
gameController.startNextSpin = false;
gameController.cachedStart = false;
gameController.winSkipped = false;
gameController.spinHasWin = false;
gameController.animWinsFinished = true;
gameController.stoppingAutoplay = false;

gameController.lightningStriking = false;
gameController.stormLinkPayout = false;

gameController.wildTimers = [];

gameController.loseStreak = 0;

gameController.reelsAlreadyLanded = [];

gameController.retriggerTask = undefined;
gameController.doBigWinShake = false;

gameController.idleMusicTimer = undefined;

gameController.inBuyABonus = false;
gameController.buyABonusFireball = false;
gameController.stormLinkSkip = true;

gameController.platformPopupActive = false;

// these are used to play a special sound on the eigth fireball landing
gameController.eigthFireballLanded = false;
gameController.allReelFireballCount = 0;

gameController.bonusLandSndIndex = 0;

gameController.justHadFreeSpins = false;
gameController.justHadFbl = false;

// for multiple reel spin sounds
gameController.reelspins = ["reelSpin"];
gameController.reelspinId = 0;
gameController.inFirelink = false;

gameController.winlineSound = 0;
gameController.winlineSounds = ["winCycle0", "winCycle1", "winCycle2"];

gameController.thunderballLandSound = [
  "thunderballLand0",
  "thunderballLand1",
  "thunderballLand2",
];

gameController.isWildFire = false;

gameController.freespinsWinnings = 0;
gameController.stormlinkWinnings = 0;
gameController.potBonusWinnings = 0;

gameController.initialise = function () {
  gameController.bigWin = resourceManager.get("bigWin");

  gameController.slotMachine = resourceManager.getController("SlotMachine");
  const reelNames = ["reel0", "reel1", "reel2", "reel3", "reel4", "reel5"];
  gameController.slotMachine.subscribeToReelsLandedEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);
    if (gameController.reelsAlreadyLanded.indexOf(reel) === -1) {
      gameController.onSpinLand(reel);
    }
    gameController.reelsAlreadyLanded.push(reel);
  });
  gameController.slotMachine.subscribeToReelsHitEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);
    gameController.playLandSounds(reel);
    gameController.onSpinHit(reel);
  });
  for (let i = 0; i < gameData.numReels; ++i) {
    let rv = resourceManager.get("slotContainer:reelContainer:reel" + i);

    rv.reassignSlotMachine(gameController.slotMachine);
  }

  gameController.redrawSymbols(gameController.slotMachine);

  gameController.slotMachine.selectReelMode("default");

  gameController.winlineAnimator = resourceManager.getSharedPlugin(
    "GameWinlineCatMullRomAnimatorEx"
  );

  gameController.firelink = resourceManager.get(
    "slotContainer:firelinkFeatureContainer:firelinkFeature"
  );

  gameController.originalStopDistances =
    gameController.slotMachine._currentMode.stopDistances;

  gameController.winningsContainer = resourceManager.get("winningsContainer");
  gameController.winningsContainer.visible = false;

  gameController.reelBackerGlow = resourceManager.get(
    "slotContainer:reelContainer:frameBackerGlow"
  );
  gameController.reelBackerGlowPos = 0;

  gameController.panels = [];

  for (let i = 0; i < 6; i++) {
    const panel = resourceManager.get(
      "slotContainer:reelContainer:frameBacker" + i
    );
    gameController.panels.push(panel);
  }

  gameController.longSpinParticles = [
    {
      left: resourceManager.get("slotContainer:reelEffects:reel0Effect"),
      right: resourceManager.get("slotContainer:reelEffects:reel1Effect"),
    },
    {
      left: resourceManager.get("slotContainer:reelEffects:reel1Effect"),
      right: resourceManager.get("slotContainer:reelEffects:reel2Effect"),
    },
    {
      left: resourceManager.get("slotContainer:reelEffects:reel2Effect"),
      right: resourceManager.get("slotContainer:reelEffects:reel3Effect"),
    },
    {
      left: resourceManager.get("slotContainer:reelEffects:reel3Effect"),
      right: resourceManager.get("slotContainer:reelEffects:reel4Effect"),
    },
    {
      left: resourceManager.get("slotContainer:reelEffects:reel4Effect"),
      right: resourceManager.get("slotContainer:reelEffects:reel5Effect"),
    },
    {
      left: resourceManager.get("slotContainer:reelEffects:reel5Effect"),
      right: resourceManager.get("slotContainer:reelEffects:reel6Effect"),
    },
  ];
  gameController.stopAnticipation();

  gameController.redLightningAnticipations = [];

  for (let i = 0; i < 7; i++) {
    let anim = resourceManager.get(
      "slotContainer:reelEffects:reel" + i + "EffectRed"
    );
    gameController.redLightningAnticipations.push(anim);
    anim.gotoAndStop(0);
    anim.visible = false;
  }

  gameController.colorMatrix = new PIXI.filters.ColorMatrixFilter();
  gameController.colorMatrix.hue(145, false);

  gameController.colorMatrixMoutains = new PIXI.filters.ColorMatrixFilter();
  gameController.colorMatrixMoutains.hue(-28, false);

  gameController.redLightning = resourceManager.get(
    "slotContainer:redLightning"
  );
  gameController.redLightning.filters = [gameController.colorMatrix];
  gameController.redLightning.visible = false;
  gameController.redLightning.gotoAndStop(0);
  gameController.redLightningStart = { x: 230, y: 146 };
  gameController.redLightningEnd = { x: 1166, y: 146 };

  gameController.createRedLightningAnim();

  gameController.redSkyItems = [
    {
      item: resourceManager.get("baseGameBackground:vortex"),
      filter: gameController.colorMatrix,
    },
    {
      item: resourceManager.get("baseGameBackground:eye"),
      filter: gameController.colorMatrix,
    },
    {
      item: resourceManager.get(
        "baseGameBackground:landscapeBackground:clouds"
      ),
      filter: gameController.colorMatrix,
    },
    {
      item: resourceManager.get(
        "baseGameBackground:landscapeBackground:mountains"
      ),
      filter: gameController.colorMatrixMoutains,
    },
    {
      item: resourceManager.get("baseGameBackground:portraitBackground:clouds"),
      filter: gameController.colorMatrix,
    },
    {
      item: resourceManager.get(
        "baseGameBackground:portraitBackground:mountains"
      ),
      filter: gameController.colorMatrixMoutains,
    },
  ];

  gameController.winControllerMain =
    resourceManager.getController("WinControllerMain");

  gameController.scatterSymbolReels = [];
  gameController.reelFireballs = [];
  for (let i = 0; i < gameData.numReels; ++i) {
    let rowFireballs = [];
    for (let row = 0; row < gameData.numRows; ++row) {
      const fireball = resourceManager.get(
        "slotContainer:reelFireballs:fireball_" + i + "_" + row
      );
      rowFireballs.push(fireball);
    }
    gameController.reelFireballs.push(rowFireballs);
  }

  gameController.symbolAnimator = resourceManager.get(
    "slotContainer:SymbolAnimator"
  );
  gameController.symbolLandAnimator = resourceManager.get(
    "slotContainer:BonusLandAnimator"
  );
  gameController.wildLandAnimator = resourceManager.get(
    "slotContainer:WildLandAnimator"
  );

  gameController._18timeslogo = resourceManager.get(
    "slotContainer:logo18times"
  );
  gameController._18timeslogo.visible = false;

  gameController._fblLogo = resourceManager.get("slotContainer:stormLinkLogo");
  gameController._fblLogo.visible = false;

  resourceManager.get("fireballLinkIntroDim").visible = false;
  gameController.wildFire = resourceManager.get(
    "slotContainer:reelEffects:wildFireContainer:wildFireAnim"
  );

  gameController.onOrientationChange();

  gameController.shaker = resourceManager.get("slotShaker");
  gameController.nightBackground = resourceManager.get(
    "baseGameBackground:landscapeBackground:mountainsFreeSpins"
  );
  gameController.nightBackgroundPortrait = resourceManager.get(
    "baseGameBackground:portraitBackground:mountainsFreeSpins"
  );

  gameController.popoutInitialWilds();
};

gameController.redrawSymbols = function (sm) {
  let reelVisuals = sm._reelVisuals;
  for (let i = 0; i < reelVisuals.length; ++i) {
    reelVisuals[i].redraw();
  }
};

gameController.popoutInitialWilds = function () {
  const symbols = resourceManager.getConfiguration().symbols;
  let symbolsToAnimate = [];
  for (
    let reel = 0;
    reel < gameData.slotConfig.startingSymbols.length;
    ++reel
  ) {
    for (
      let row = 0;
      row < gameData.slotConfig.startingSymbols[reel].symbols.length;
      ++row
    ) {
      const symbolId =
        gameData.slotConfig.startingSymbols[reel].symbols[row].value;
      if (symbolId === symbols["Symbol_SWild"].ID) {
        let symbolData = {
          cell: { reel: reel, row: row },
          symbolId: symbols["Symbol_SWild"].ID,
        };
        gameController.wildSymbolsToStandOut.push(symbolData);
        symbolsToAnimate.push(symbolData);
      } else if (symbolId === symbols["Symbol_SWild_x2"].ID) {
        let symbolData = {
          cell: { reel: reel, row: row },
          symbolId: symbols["Symbol_SWild_x2"].ID,
        };
        gameController.wildSymbolsToStandOut.push(symbolData);
        symbolsToAnimate.push(symbolData);
      } else if (symbolId === symbols["Symbol_SWild_x3"].ID) {
        let symbolData = {
          cell: { reel: reel, row: row },
          symbolId: symbols["Symbol_SWild_x3"].ID,
        };
        gameController.wildSymbolsToStandOut.push(symbolData);
        symbolsToAnimate.push(symbolData);
      }
    }
  }

  if (symbolsToAnimate.length > 0) {
    gameController.wildLandAnimator.animateSymbols(
      symbolsToAnimate,
      gameController.slotMachine,
      true,
      true,
      function () {}
    );
  }
};

gameController.playLandSounds = function (reel) {
  let fireballsOnThisReel = gameController.countFireballsOnReel(reel);

  // keep a running total of fireballs landed as the 8th one needs a different sound
  gameController.allReelFireballCount += fireballsOnThisReel;

  soundManager.play("reelStop" + reel);

  // play sound if fireball on reel - special case for eigth fireball
  if (fireballsOnThisReel > 0) {
    if (
      gameController.allReelFireballCount >=
        gameController.minBonusForFeature2 &&
      !gameController.eigthFireballLanded
    ) {
      soundManager.play("thunderballExplode");
      gameController.eigthFireballLanded = true;
    } else {
      let soundIndex = Math.floor(
        Math.random() * gameController.thunderballLandSound.length
      );

      soundManager.play(gameController.thunderballLandSound[soundIndex]);
    }
  }
};

gameController.start = function () {
  gameController.stateMachine.switchState("WAITING_FOR_START");
};

gameController.shuffle = function (array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
};

gameController.onSpinComplete = function () {
  if (gameController.spinTask.data.isWildFire) {
    gameController.wildFire.convertFireballsToFireballWilds(
      gameController.spinTask.data.wildFireFireballs
    );

    gameController.removeRedSky();
  }

  gameController.spinComplete = true;
  soundManager.stop("reelSpin");
  //gameController.slotMachine.clearHighlightSymbolIds();
  //if(!gameController.slamStopped) {
  gameController.setState_WaitingForServer(gameController.spinTask);
  //}
};

gameController.animateFSSpinSymbolLand = function (reel) {};

gameController.animateFSSpinSymbolWin = function (reel, callback) {};

gameController.isBonusThisSpin = function () {
  let bonusCount = 0;
  for (let i = 0; i < gameData.numReels; i++) {
    bonusCount += gameController.countBonusOnReel(i);
  }
  return bonusCount >= gameController.minBonusForFeature;
};

gameController.countSymbolOnReel = function (reel, symbolString) {
  let reelSymbols = [];
  if (gameController.spinTask.data.resultsPanel !== undefined) {
    reelSymbols =
      gameController.spinTask.data.resultsPanel.reelList[reel].symbols;
  }
  if (gameController.spinTask.data.resultPanel !== undefined) {
    reelSymbols =
      gameController.spinTask.data.resultPanel.reelList[reel].symbols;
  }

  const symbols = resourceManager.getConfiguration().symbols;
  const found = reelSymbols.find(function (symbol) {
    return symbol.value === symbols[symbolString].ID;
  });

  if (found !== undefined) {
    return 1;
  } else {
    return 0;
  }
};

gameController.countBonusOnReel = function (reel) {
  return gameController.countSymbolOnReel(reel, "Symbol_Bonus");
};

gameController.countRetriggerBonusOnReel = function (reel) {
  return gameController.countSymbolOnReel(reel, "Symbol_Bonus_Retrigger");
};

gameController.countFireballsOnReel = function (reel) {
  let reelSymbols = [];
  if (gameController.spinTask.data.resultsPanel !== undefined) {
    reelSymbols =
      gameController.spinTask.data.resultsPanel.reelList[reel].symbols;
  }
  if (gameController.spinTask.data.resultPanel !== undefined) {
    reelSymbols =
      gameController.spinTask.data.resultPanel.reelList[reel].symbols;
  }
  let numFireballs = 0;

  reelSymbols.forEach(function (row) {
    if (gameController.symbolIsFireball(row.value)) {
      ++numFireballs;
    }
  });

  return numFireballs;
};

gameController.onSpinLand = function (reel) {
  gameData.reels[reel].clearDimSymbolIds(0.3);

  if (reel === 5) {
    if (!gameController.inFreeSpins && !gameController.inFirelink) {
      const stakeController = resourceManager.getController("stakeController");
      const stake = stakeController.getCurrentStake("default");

      if (gameController.spinHasWin > stake) {
        gameData.musicManager.increaseLevel("base");

        gameController.loseStreak = 0;
      } else {
        gameController.loseStreak++;

        if (gameController.loseStreak === 10) {
          gameData.musicManager.fadeLevels(1, "base");
        }
      }
    }
  }

  gameData.reelsSpinning--;

  if (!gameController.inFreeSpins) {
    if (gameData.reelsSpinning === 0) {
      soundManager.stop(gameController.currentReelSpin);

      gameController.stopAnticipation();

      if (
        gameController.bonusSymbolsLanded < gameController.minBonusForFeature
      ) {
        gameController.symbolLandAnimator.skip();
      }
    }
  }

  const symbols = resourceManager.getConfiguration().symbols;
  let symbolsToAnimate = [];
  let row = 0;
  for (
    ;
    row <
    gameController.spinTask.data.resultPanel.reelList[reel].symbols.length;
    ++row
  ) {
    if (
      gameController.spinTask.data.resultPanel.reelList[reel].symbols[row]
        .value === symbols["Symbol_SWild"].ID
    ) {
      let symbolData = {
        cell: { reel: reel, row: row },
        symbolId: symbols["Symbol_SWild"].ID,
      };
      gameController.wildSymbolsToStandOut.push(symbolData);
      symbolsToAnimate.push(symbolData);
    } else if (
      gameController.spinTask.data.resultPanel.reelList[reel].symbols[row]
        .value === symbols["Symbol_SWild_x2"].ID
    ) {
      let symbolData = {
        cell: { reel: reel, row: row },
        symbolId: symbols["Symbol_SWild_x2"].ID,
      };
      gameController.wildSymbolsToStandOut.push(symbolData);
      symbolsToAnimate.push(symbolData);
    } else if (
      gameController.spinTask.data.resultPanel.reelList[reel].symbols[row]
        .value === symbols["Symbol_SWild_x3"].ID
    ) {
      let symbolData = {
        cell: { reel: reel, row: row },
        symbolId: symbols["Symbol_SWild_x3"].ID,
      };
      gameController.wildSymbolsToStandOut.push(symbolData);
      symbolsToAnimate.push(symbolData);
    }
  }
  if (symbolsToAnimate.length > 0) {
    gameController.wildLandAnimator.animateSymbols(
      symbolsToAnimate,
      gameController.slotMachine,
      true,
      true,
      function () {}
    );
  }
};

gameController.onSpinHit = function (reel) {
  const onReel = gameController.countBonusOnReel(reel);

  gameController.bonusSymbolsLanded += onReel;

  const reelsNotLanded = gameData.numReels - reel;

  if (gameController.inFreeSpins) {
    const retrigger = gameController.countRetriggerBonusOnReel(reel);

    if (retrigger) {
      soundManager.play("freeSpinsBonusLand");
    }
  } else {
    if (onReel) {
      if (
        gameController.bonusSymbolsLanded + reelsNotLanded >
        gameController.minBonusForFeature
      ) {
        const symbols = resourceManager.getConfiguration().symbols;
        let row = 0;
        for (
          ;
          row <
          gameController.spinTask.data.resultPanel.reelList[reel].symbols
            .length;
          ++row
        ) {
          if (
            gameController.spinTask.data.resultPanel.reelList[reel].symbols[row]
              .value === symbols["Symbol_Bonus"].ID
          ) {
            break;
          }
        }
        let symbolData = {
          cell: { reel: reel, row: row },
          symbolId: symbols["Symbol_Bonus"].ID,
        };

        if (gameController.slamStopped) {
          if (gameController.playSingleBonus) {
            soundManager.play("bonusLand0");
            gameController.playSingleBonus = false;
          }
        } else {
          soundManager.play("bonusLand" + gameController.bonusLandSndIndex);
          gameController.bonusLandSndIndex++;
        }

        gameController.symbolLandAnimator.animateSymbols(
          [symbolData],
          gameController.slotMachine,
          true,
          true,
          function () {}
        );
      }
    }
  }

  const fireballsOnReel = gameController.countFireballsOnReel(
    reel,
    "Symbol_Bonus"
  );
  gameController.fireballsLanded += fireballsOnReel;

  const scatterBonusAnticipation =
    gameController.bonusSymbolsLanded >=
      gameController.minBonusForFeature - 1 &&
    gameController.bonusSymbolsLanded + reelsNotLanded >=
      gameController.minBonusForFeature;
  const scatterBonusIsPossible =
    gameController.fireballsLanded >=
      gameController.minBonusForFeature2Anticipation &&
    gameController.fireballsLanded + reelsNotLanded * gameData.numRows >=
      gameController.minBonusForFeature2;

  if (
    reel < gameData.numReels - 1 &&
    (scatterBonusAnticipation || scatterBonusIsPossible)
  ) {
    gameController.stopAnticipation();

    let reelIndex = reel + 2;
    soundManager.play("anticipation" + reelIndex);

    gameController.longSpinParticles[reel + 1].left.gotoAndPlay(0);
    gameController.longSpinParticles[reel + 1].left.visible = true;
    gameController.longSpinParticles[reel + 1].right.gotoAndPlay(15);
    gameController.longSpinParticles[reel + 1].right.visible = true;

    gameController.reelBackerGlow.visible = true;
    gameController.reelBackerGlowPos =
      gameController.panels[reel + 1].position.x;
    gameController.reelBackerGlow.x = gameController.reelBackerGlowPos;
  } else {
    gameController.stopAnticipation();
  }
};

gameController.setRedSky = function () {
  //Hello future dev. This may have been fixed in a later version of pixi.
  //But for now you can't manipulate array of filters.
  gameController.redSkyItems.forEach((object) => {
    const item = object.item;
    const filter = object.filter;

    if (item.filters === null) {
      item.filters = [];
    }
    item.filters = [...item.filters, filter];
  });
};

gameController.removeRedSky = function () {
  gameController.redSkyItems.forEach((object) => {
    const item = object.item;
    const filter = object.filter;
    const index = item.filters.indexOf(filter);
    const copy = [...item.filters];

    if (index > -1) {
      copy.splice(index, 1);
    }

    item.filters = copy;
  });
};

gameController.createRedLightningAnim = function () {
  gameController.redLightningTimeline = gsap
    .timeline({ paused: true })
    .call(() => {
      gameController.redLightning.visible = true;
      gameController.redLightning.gotoAndPlay(0);

      gameController.redLightning.x = gameController.redLightningStart.x;
      gameController.redLightning.y = gameController.redLightningStart.y;
    })
    .to(gameController.redLightning, {
      duration: 1.5,
      x: gameController.redLightningEnd.x,
      ease: "none",
    })
    .call(() => {
      gameController.redLightning.visible = false;
      gameController.redLightning.gotoAndStop(0);
    });
};

gameController.startRedLightning = function () {
  soundManager.play("redLightning");
  game.thunderAnim.play(0);

  gameController.setRedSky();
  gameController.redLightningTimeline.play(0);

  gameData.reels.forEach(function (reel) {
    reel.turnFireballsBlue(true);
  });

  let startTime = 0;
  let incTime = 250;

  gameController.redLightningAnticipations.forEach((anim) => {
    timerManager.addTimeout(startTime, function () {
      let ran = Math.floor(Math.random() * 30);
      anim.visible = true;
      anim.gotoAndPlay(ran);
    });

    startTime += incTime;
  });

  timerManager.addTimeout(2500, function () {
    gameController.redLightningAnticipations.forEach((anim) => {
      anim.gotoAndStop(0);
      anim.visible = false;
    });
  });
};

gameController.stopAnticipation = function () {
  // stop all anticipation sounds
  for (let i = 3; i <= 6; i++) {
    soundManager.stop("anticipation" + i);
  }

  gameController.longSpinParticles.forEach(function (effect) {
    effect.left.gotoAndStop(0);
    effect.left.visible = false;
    effect.right.gotoAndStop(0);
    effect.right.visible = false;
  });

  gameController.reelBackerGlow.visible = false;
};

gameController.symbolIsFireball = function (symbolId) {
  const symbolsInfo = resourceManager.getConfiguration().symbols;
  return (
    symbolId >= symbolsInfo["Symbol_Fireball20"].ID &&
    symbolId <= symbolsInfo["Symbol_BlueFireballMega"].ID
  );
};

gameController.doSpin = function (spinTask) {
  // Update autoplay button text
  if (resourceManager.getController("autoplayController").Enabled) {
    resourceManager
      .getController("inputOverlord")
      .setText(
        "autoplayCancelButton",
        String(autoplayManager.getRemainingRounds())
      );
  }

  gameController.bigWin.hideText();

  gameController.totalWinnings = 0;

  gameController.isPrePaid = spinTask.data.isPrePaidGame;

  gameController.spinHasWin = spinTask.data.totalWinnings;

  gameController.stateMachine.switchState("SPIN_REELS_SPINNING");

  gameData.reelsSpinning = gameData.numReels;

  gameController.longSpinReels = [false, false, false, false, false, false];
  let numBonus = 0;
  let numFireballs = 0;
  const symbolsInfo = resourceManager.getConfiguration().symbols;
  // Set up data for the reels
  let symbols = [];
  let above = [];
  let below = [];
  for (let reel = 0; reel < spinTask.data.resultPanel.reelList.length; reel++) {
    if (numBonus >= gameController.minBonusForFeature - 1) {
      gameController.longSpinReels[reel] = true;
    }
    if (numFireballs >= gameController.minBonusForFeature2Anticipation) {
      gameController.longSpinReels[reel] = true;
    }

    symbols.push([]);
    above.push([]);
    below.push([]);
    for (
      let row = 0;
      row < spinTask.data.resultPanel.reelList[reel].symbols.length;
      row++
    ) {
      const symbolId =
        spinTask.data.resultPanel.reelList[reel].symbols[row].value;
      symbols[reel].push(symbolId);
      if (symbolId === symbolsInfo["Symbol_Bonus"].ID) {
        numBonus++;
      }
      if (gameController.symbolIsFireball(symbolId)) {
        numFireballs++;
      }
    }
    for (
      let row = 0;
      row < spinTask.data.resultPanel.symbolsAbove[reel].symbols.length;
      row++
    ) {
      above[reel].push(
        spinTask.data.resultPanel.symbolsAbove[reel].symbols[row].value
      );
    }
    for (
      let row = 0;
      row < spinTask.data.resultPanel.symbolsBelow[reel].symbols.length;
      row++
    ) {
      below[reel].push(
        spinTask.data.resultPanel.symbolsBelow[reel].symbols[row].value
      );
    }
  }

  //Anticipation
  gameController.slotMachine._currentMode.stopDistances =
    gameController.originalStopDistances;
  let newStopDistances = [];
  for (let r = 0; r < gameController.longSpinReels.length; ++r) {
    newStopDistances.push(gameController.originalStopDistances[r]);
    if (gameController.longSpinReels[r]) {
      if (gameController.inFreeSpins) {
        newStopDistances[r - 1] += 20;
      } else {
        newStopDistances[r - 1] += 20;
      }
    }
  }

  gameController.slotMachine._currentMode.stopDistances = newStopDistances;

  gameController.isWildFire = spinTask.data.isWildFire;
  gameController.isFbl = spinTask.data.isFbl;
  gameController.isPotBonus = spinTask.data.isPotBonus;

  if (gameController.isWildFire) {
    soundManager.play("thunder");
    soundManager.play("lightningPunch");

    timerManager.addTimeout(2000, function () {
      gameController.startRedLightning();

      gameController.shaker.doShake(2000, function () {
        timerManager.addTimeout(1000, function () {
          gameController.slotMachine.stopReels(
            symbols,
            above,
            below,
            gameController.onSpinComplete
          );
        });
      });
    });
  } else if (gameController.inFreeSpins) {
    const time = 250 * spinTask.data.newActivations.length;
    timerManager.addTimeout(2000 + time, function () {
      gameController.slotMachine.stopReels(
        symbols,
        above,
        below,
        gameController.onSpinComplete
      );
    });
  } else {
    gameController.slotMachine.stopReels(
      symbols,
      above,
      below,
      gameController.onSpinComplete
    );
  }

  gameData.spinData = spinTask.data;
  gameController.spinTask = spinTask;
  gameController.spinTask.join();
};

gameController.initNewSpin = function () {
  timerManager.stop(gameController.cycleWinsDelayTimer);

  gameController.cancelWildTimers();
  gameController.stopAnticipation();

  gameController.reelsAlreadyLanded = [];
  gameController.startNextSpin = false;
  gameController.cachedStart = false;
  gameController.winSkipped = false;
  gameController.spinHasWin = false;

  gameController.doBigWinShake = false;

  gameController.wildLandAnimator.skip();
  gameController.wildSymbolsToStandOut = [];

  gameController.winControllerMain.skipAnimations();

  const goldenBetButton = resourceManager.get("goldenBetToggleButton");
  goldenBetButton.onSpin();

  timerManager.addTimeout(100, function () {
    gameData.reels.forEach(function (reel) {
      reel.lockFireballCashValues(false);
    });
  });

  gameData.reels.forEach(function (reel) {
    reel.turnFireballsBlue(false);
  });

  gameController.eigthFireballLanded = false;
  gameController.allReelFireballCount = 0;

  gameController.bonusLandSndIndex = 0;

  gameController.bonusSymbolsLanded = 0;
  gameController.fireballsLanded = 0;
  gameController.isWildFire = false;
  gameController.slamStopped = false;
  gameController.playSingleBonus = true;
  gameController.waitingForLandAnim = false;
  gameController.cyclingWins = false;
  gameController.bigWin._newSpin = true;
  gameController.bigWin._newSpin = false;
  gameController.lastPayWinsData = undefined;
  gameController.spinComplete = false;

  gameController.winningsContainer.visible = false;
  gameData.winningsMeter.set(0);

  if (gameController.currentReelSpin !== undefined) {
    soundManager.stop(gameController.currentReelSpin);
  }
  if (!gameController.inFreeSpins && !autoplayManager.isAutoplayEnabled()) {
    // we only have one reel spin sound
    //gameController.currentReelSpin = soundManager.play(gameController.reelspins[(gameController.reelspinId++) % gameController.reelspins.length]);
    gameController.currentReelSpin = soundManager.play(
      gameController.reelspins[0]
    );
  }

  gameController.winlineAnimator.skipAnimation();
  gameController.slotMachine.infiniteSpin();
  gameController.setState_WaitingForServer();
  gameController.featurePrize = 0;
  gameController.reelsPrize = 0;

  if (!gameController.inFreeSpins) {
    gameController.stopIdleMusicTimer();

    if (gameData.musicManager.getMusicLevel() === 0) {
      gameData.musicManager.increaseLevel("base");
    }
  }
};

//////////////////////////////////////////////////
gameController.stopIdleMusicTimer = function () {
  timerManager.stop(gameController.idleMusicTimer);
  gameController.idleMusicTimer = undefined;
};

gameController.initNewGame = function () {
  gameController.preFSReelPrize = 0;
  gameController.stateMachine.switchState("GAME_PLAYING");
  gameController.initNewSpin();

  if (resourceManager.getController("autoplayController").Enabled) {
    resourceManager
      .getController("inputOverlord")
      .setText(
        "autoplayCancelButton",
        String(autoplayManager.getRemainingRounds())
      );
    resourceManager
      .getController("inputOverlord")
      .setText(
        "autoplayCancelButton_portrait",
        String(autoplayManager.getRemainingRounds())
      );
  }
};

gameController.startGame = function () {
  gameController.justHadFreeSpins = false;
  gameController.justHadFbl = false;
  gameController.stoppingAutoplay = false;
  gameController.initNewGame();

  const stakeController = resourceManager.getController("stakeController");
  let bpl = stakeController.BaseStake / stakeController.CurrentWinLineCount;

  gdk.startGame(
    {
      stake: stakeController.CurrentStake,
      numWinlines: stakeController.CurrentWinLineCount,
      bpl: bpl,
      metaData: {
        buyABonus: false,
        encore: gameData.encoreEnabled,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

gameController.setState_WaitingForServer = function (eventToLeave) {
  if (!gameController.inFreespins) {
    // Only monitor how long we are waiting for server if we arent in freespins
    gameController.stateMachine.switchState("WAITING_FOR_SERVER");
  }
  if (checkForDefined(eventToLeave)) {
    eventToLeave.leave();
  }
};

gameController.autoplayStarted = function (autoplayData) {
  resourceManager
    .getController("inputOverlord")
    .setText(
      "autoplayCancelButton",
      String(autoplayManager.getRemainingRounds())
    );
};

gameController.autoplayEnded = function (autoplayData) {
  resourceManager
    .getController("inputOverlord")
    .setTranslatonPhrase("autoplayButton", "t_autoplay");
};

StateMachine.Create(gameController);

gameController.stateMachine.addState("WAITING_FOR_LOAD", function () {});

gameController.cancelAutoplay = function () {
  resourceManager.getController("autoplayController").cancel();
};

gameController.stateMachine.addState("WAITING_FOR_START", function () {
  if (gameController.phase.enter()) {
  }

  if (gameController.phase.timed(300)) {
  }

  if (gameController.phase.hold()) {
    if (!resourceManager.getController("autoplayController").LimitPopupOpen) {
      gameController.phase.step();
    }
  }

  if (gameController.phase.once()) {
    if (
      !autoplayManager.isAutoplayEnabled() &&
      !gameController.justHadFreeSpins &&
      !gameController.startNextSpin &&
      !gameController.justHadFbl
    ) {
      gameController.cyclingWins = true;
      gameController.cycleWins();
    }
  }

  if (gameController.phase.hold()) {
    // Waiting for player to do something
    if (autoplayManager.isAutoplayEnabled()) {
      if (
        autoplayManager.AP.getFields()["numberOfRounds"].currentValue !==
        autoplayManager.AP.roundsRemaining()
      ) {
        resourceManager.getController(
          "autoplayController"
        ).timeToNextAutoplay = 500; //dlConst.DELAY_BETWEEN_SPINS;
        gameController.phase.step();
      }
    } else if (gameController.startNextSpin) {
      gameController.phase.step();
    }
  }
  if (!gameController.startNextSpin) {
    if (
      gameController.phase.timed(
        resourceManager.getController("autoplayController").timeToNextAutoplay
      )
    ) {
    }
  }
  if (gameController.phase.once()) {
    if (gameController.stoppingAutoplay) {
      gameController.stoppingAutoplay = false;
      gameController.cancelAutoplay();
    } else {
      gameController.startGame();
    }

    if (autoplayManager.AP.roundsRemaining() === 0) {
      // Last round, so cancel autoplays
      gameController.cancelAutoplay();
    }
  }
});

gameController.stateMachine.addState("RETRIGGER", function () {
  if (gameController.phase.enter()) {
  }

  if (gameController.phase.hold()) {
    if (!soundManager.isSoundPlaying("BellRing")) {
      gameController.phase.step();
    }
  }

  if (gameController.phase.once()) {
    gameController.retriggerTask.leave();
    gameController.retriggerTask = undefined;

    gameController.stateMachine.switchState("WAITING_FOR_SERVER");
  }
});

gameController.stateMachine.addState("SPIN_REELS_SPINNING", function () {});

gameController.stateMachine.addState("WAITING_FOR_SERVER", function () {});

gameController.stateMachine.addState("PAYING_TO_WINNINGS", function () {
  if (gameController.phase.enter()) {
    winMeter.meter.cancelCountUp();
  }

  if (gameController.phase.hold()) {
    if (!gameData.winningsMeter.Props.isCounting) {
      // Finished counting
      if (!gameData.slotConfig.promotionActive) {
        resourceManager.get("winningsMeterLabel").visible = true;
      }
      gameController.unFadeSymbols();
      timerManager.addTimer(
        1000,
        undefined,
        gameController.onDelayShowWinningsComplete
      );
      gameController.stateMachine.switchState("DELAY_SHOW_WINNINGS");
    } else {
      if (!gameData.slotConfig.promotionActive) {
        resourceManager.get("winningsMeterLabel").visible =
          gameController.gameTime % 200 < 100;
      }
    }
  }

  if (gameController.phase.exit()) {
    if (!gameData.slotConfig.promotionActive) {
      resourceManager.get("winningsMeterLabel").visible = true;
    }
  }
});

gameController.stateMachine.addState("GAME_PLAYING", function () {
  if (gameController.phase.enter()) {
  }
});

gameController.stateMachine.addState("GAME_ENDED", function () {
  if (gameController.phase.enter()) {
    gdk.addTotalGameWinningsToQueue();
    gdk.addBalanceEventToQueue();
  }
  if (gameController.phase.once()) {
    gdk.endGame(function () {
      gameController.stateMachine.switchState("WAITING_FOR_START");
      gameController.baseSpin = true;
    });
  }
});

gameController.stateMachine.switchState("WAITING_FOR_LOAD");

gameController.update = function (delta, time) {
  gameController.stateMachine.update();
};

gameController.cycleWins = function () {
  if (gameController.cyclingWins) {
    if (
      gameController.lastPayWinsData !== undefined &&
      gameController.lastPayWinsData.winningLines !== undefined
    ) {
      gameController.cyclingWinsIndex = 0;
      gameController.cycleWin();
    }
  }
};

gameController.cycleWin = function () {
  if (!gameController.bigWin.isCurrentlyPlaying()) {
    soundManager.play(
      gameController.winlineSounds[gameController.winlineSound]
    );
    gameController.winlineSound++;
  }

  if (gameController.winlineSound >= gameController.winlineSounds.length) {
    gameController.winlineSound = 0;
  }

  const stakeController = resourceManager.getController("stakeController");
  gameController.symbolAnimating = true;
  const data =
    gameController.lastPayWinsData.winningLines[
      gameController.cyclingWinsIndex
    ];
  let symbols = [];
  for (let i = 0; i < data.positions.length; ++i) {
    symbols.push({
      cell: { reel: data.positions[i].reel, row: data.positions[i].row },
      symbolId: data.symbol.ids[i],
    });
  }
  let canCelebrate = this.lastPayWinsData.winnings > stakeController.BaseStake;

  gameController.symbolAnimator.animateSymbols(
    symbols,
    gameController.slotMachine,
    canCelebrate,
    false,
    function () {},
    function () {}
  );
  gameController.animating = true;

  gameController.winlineAnimator.playAnimations(
    [
      gameController.lastPayWinsData.winningLines[
        gameController.cyclingWinsIndex
      ],
    ],
    symbols,
    gameController.slotMachine,
    function () {}
  );
  //gameController.winCounter.jumpTo(gameController.lastPayWinsData.winningLines[gameController.cyclingWinsIndex].winAmount);
  //gameController.animateLineWinText();

  timerManager.addTimer(2500, undefined, function () {
    gameController.animating = false;
    gameController.symbolAnimating = false;
    gameController.symbolAnimator.skip();
    gameController.winlineAnimator.skipAnimation();
    //gameController.winCounter.finish();
    gameController.cycleNextWin();
  });
};

gameController.cycleNextWin = function () {
  if (
    gameController.cyclingWins &&
    !gameController.symbolAnimating &&
    !gameController.animating &&
    gameController.lastPayWinsData &&
    gameController.lastPayWinsData.winningLines
  ) {
    ++gameController.cyclingWinsIndex;
    if (
      gameController.cyclingWinsIndex <
      gameController.lastPayWinsData.winningLines.length
    ) {
      gameController.cycleWin();
    } else {
      gameController.cycleWins();
    }
  }
};

gameController.onLimitsPopupClosed = function () {
  soundManager.play(gameData.sounds.buttonPressed);
  gameController.stateMachine.switchState("GAME_ENDED");
};

// helper function to get the current stake based on game mode
// e.g. base game, buy a bonus, golden bet - don't recalculate here it's returned correctly
gameController.getCurrentModeStake = function (ignoreGoldenBetMultiplier) {
  let stake = 0;
  const stakeController = resourceManager.getController("stakeController");

  if (stakeController) {
    stake = stakeController.getCurrentStake("default");

    if (gameController.inBuyABonus) {
      if (gameController.buyABonusFireball) {
        stake = stakeController.getCurrentStake("FIREBALL_BUY");
      }
    }

    // in golden bet the fireball values are based on the base stake so multiply down
    let goldenBetButton = resourceManager.get("goldenBetToggleButton");
    if (
      ignoreGoldenBetMultiplier &&
      goldenBetButton !== undefined &&
      goldenBetButton._flags.showGoldenBetActive
    ) {
      stake = stake / 1.25;
    }
  }
  return stake;
};

gameController.onStakeChanged = function (stake) {
  if (stake === undefined) {
    return;
  }

  gameController.updatePots(stake);

  if (gameData.stakeMeter.value !== stake) {
    gameData.reels.forEach(function (reel) {
      reel.lockFireballCashValues(true);
    });

    gameController.winningsContainer.visible = false;

    gameData.stakeMeter.set(stake);

    gameController.cyclingWins = false;
    gameController.lastPayWinsData = undefined;
    gameData.winningsMeter.set(0);
    gdk.playerChangedStake(stake);
  }
};

gameController.cancelWinlines = function () {
  gameController.winlineAnimator.skipAnimation();
  gameController.cyclingWins = false;
  gameController.lastPayWinsData = undefined;
};

gameController.updatePots = function (stake) {
  const miniPot = resourceManager.get("potContainer:mini:value");
  const minorPot = resourceManager.get("potContainer:minor:value");
  const majorPot = resourceManager.get("potContainer:major:value");
  const megaPot = resourceManager.get("potContainer:mega:value");

  const miniPotHelp = resourceManager.get(
    "helpPageScroll:scrollArea:scrollContainer:pickBonus:mini:value"
  );
  const minorPotHelp = resourceManager.get(
    "helpPageScroll:scrollArea:scrollContainer:pickBonus:minor:value"
  );
  const majorPotHelp = resourceManager.get(
    "helpPageScroll:scrollArea:scrollContainer:pickBonus:major:value"
  );
  const megaPotHelp = resourceManager.get(
    "helpPageScroll:scrollArea:scrollContainer:pickBonus:mega:value"
  );

  const goldenBetButton = resourceManager.get("goldenBetToggleButton");
  if (
    goldenBetButton !== undefined &&
    goldenBetButton._flags.showGoldenBetActive
  ) {
    stake = stake / 1.25;
  }

  miniPot.setText(gdk.formatCurrency(stake * 20));
  minorPot.setText(gdk.formatCurrency(stake * 50));
  majorPot.setText(gdk.formatCurrency(stake * 500));
  megaPot.setText(gdk.formatCurrency(stake * 5000));

  miniPotHelp.setText(gdk.formatCurrency(stake * 20));
  minorPotHelp.setText(gdk.formatCurrency(stake * 50));
  majorPotHelp.setText(gdk.formatCurrency(stake * 500));
  megaPotHelp.setText(gdk.formatCurrency(stake * 5000));
};

gameController.onGameComplete = function () {
  if (!gameController.isPrePaid && !gameController.gameRecovering) {
    gameData.creditMeter.set(
      gameData.credit +
        gameController.reelsPrize +
        gameController.freespinsWinnings +
        gameController.stormlinkWinnings +
        gameController.potBonusWinnings
    );
  }

  gameController.freespinsWinnings = 0;
  gameController.stormlinkWinnings = 0;
  gameController.potBonusWinnings = 0;
  gameController.reelsPrize = 0;

  if (
    !autoplayManager.isAutoplayEnabled() &&
    !gameController.freespinsLastSpin
  ) {
    gameController.idleMusicTimer = timerManager.addTimer(
      6000,
      function (progress) {},
      function () {
        gameData.musicManager.setIdleMusic();
        gameController.idleMusicTimer = undefined;
      }
    );
  }

  if (gameController.inBuyABonus) {
    // restore the original stake
    let stakeController = resourceManager.getController("stakeController");
    stakeController.broadcastCurrentStake("default");
  }

  // must do this here else symbols retain the buy a bonus values
  gameController.inBuyABonus = false;
  gameController.stormLinkSkip = true;

  gdk.endGame(function () {
    resourceManager.getController("autoplayController").checkLimits();
    // Check again in case we just cancelled autoplay
    if (autoplayManager.isAutoplayEnabled() === false) {
      resourceManager.getController("inputOverlord").setState("enabled");
      gameController.stateMachine.switchState("WAITING_FOR_START");
    } else {
      // Next game is AUTOPLAY
      gameController.stateMachine.switchState("WAITING_FOR_START");
    }
  });
};

gameController.doSlamStop = function () {
  if (gameData.reelsSpinning > 0) {
    gameController.slamStopped = true;

    gameController.stopAnticipation();

    gameController.reelsToSlam = [];

    for (let i = 0; i < gameController.longSpinReels.length; ++i) {
      gameController.reelsToSlam.push(i);
    }

    gameController.slotMachine.slamReels(gameController.reelsToSlam);
  }
};

gameController.finishPayWins = function () {
  gameData.reels.forEach(function (reel) {
    reel.showBlueFireballWild(false);
  });
  gameController.slotMachine.dimAllSymbols(false, 0);
};

gameController.initPayWins = function (winTask) {
  gameController.winTask = winTask;
  gameController.winTask.join();

  const canShake =
    !gameController.inFreeSpins &&
    !gameController.isFbl &&
    !gameController.isPotBonus;
  if (
    canShake &&
    gameController.bigWin.checkBigWin(winTask.data.totalLineWinnings)
  ) {
    soundManager.play("tht_horn_v1");

    gameController.shaker.doShake(1400, function () {
      gameController.doPayWins(winTask);
    });
  } else {
    gameController.doPayWins(winTask);
  }
};

gameController.doPayWins = function (winTask) {
  gameData.reels.forEach(function (reel) {
    reel.showBlueFireballWild(true);
  });

  gameController.stopAnticipation();
  gameController.reelsPrize = winTask.data.totalLineWinnings;

  if (!gameController.inFreeSpins) {
    gameController.preFSReelPrize = gameController.reelsPrize;
  }

  gameData.winningsMeter.add(winTask.data.totalLineWinnings);

  if (gameController.startNextSpin) {
    if (!gameController.bigWin.checkBigWin(gameController.reelsPrize)) {
      gameController.bigWin.start(
        gameController.reelsPrize,
        function () {
          gameController.winlineAnimsDone();
        },
        false,
        true
      );
    } else {
      gameController.finishPayWins();
      gameController.winlineAnimsDone();

      gameController.dimNoneWinningSymbols(winTask.data.winningLines);
    }
  } else {
    gameController.wildLandAnimator.skip();
    gameController.lastPayWinsData = winTask.data;

    timerManager.addTimeout(250, function () {
      gameController.animWinsFinished = false;

      gameController.dimNoneWinningSymbols(winTask.data.winningLines);

      if (!gameController.bigWin.checkBigWin(gameController.reelsPrize)) {
        timerManager.addTimeout(500, function () {
          gameController.winlinePreAnimsDone();
        });
      }

      gameController.winControllerMain.startAnimations(
        gameController.winTask.data,
        0,
        gameController.slotMachine,
        function () {
          if (gameController.bigWin.checkBigWin(gameController.reelsPrize)) {
            gameController.winlinePreAnimsDone();
          }
        },
        function (data) {}
      );
    });
  }
};

gameController.dimNoneWinningSymbols = function (winningLines) {
  let winningPositions = [];
  for (let i = 0; i < winningLines.length; ++i) {
    let winningLine = winningLines[i];
    let positions = winningLine.positions;
    for (let j = 0; j < positions.length; ++j) {
      let cell = positions[j];
      winningPositions.push(cell.reel * gameData.numReels + cell.row);
    }
  }

  let symbolsToDim = [];
  for (let reel = 0; reel < gameData.numReels; ++reel) {
    for (let row = 0; row < gameData.numRows; ++row) {
      if (winningPositions.indexOf(reel * gameData.numReels + row) === -1) {
        symbolsToDim.push({ reel: reel, row: row });
      }
    }
  }

  gameController.slotMachine.dimSymbols(symbolsToDim, true, 0.3);
};

gameController.cancelWildTimers = function () {
  gameController.wildTimers.forEach((timer) => {
    timerManager.stop(timer);
  });
};

gameController.winlinePreAnimsDone = function () {
  //Really hacky fix - I'll come back and do a proper wild animator
  gameController.wildTimers[0] = timerManager.addTimeout(300, function () {
    gameController.wildTimers[1] = timerManager.addTimer(
      2300,
      function () {
        gameController.wildLandAnimator.animateSymbols(
          gameController.wildSymbolsToStandOut,
          gameController.slotMachine,
          true,
          true,
          function () {}
        );
      },
      function () {}
    );
  });

  gameData.reels.forEach(function (reel) {
    reel.showBlueFireballWild(true);
  });
  if (!gameController.bigWin.checkBigWin(gameController.reelsPrize)) {
    gameController.bigWin.start(
      gameController.reelsPrize,
      function () {
        //winlineAnimationController.isAnimating = false;
        gameController.winlineAnimsDone();
      },
      false,
      true,
      function () {},
      false,
      false,
      gameController.winSkipped
    );
  } else {
    gameController.winlineAnimsDone();
  }
};

gameController.winlineAnimsDone = function () {
  gameController.redrawSymbols(gameController.slotMachine);
  gameController.finishPayWins();

  const duration = gameController.reelsPrize > 0 ? 1000 : 1;

  //just in case - to make sure we are not joining and leaving a task in the same tick
  timerManager.addTimeout(duration, function () {
    gameController.animWinsFinished = true;
    if (gameController.winTask) {
      gameController.winTask.leave();
      gameController.winTask = undefined;
    }
  });
};

gameController.skipWinAnimations = function () {
  gameController.bigWin.skip(gameController.winlineAnimsDone);
  gameController.winControllerMain.skipAnimations();
};

gameController.isAnimatingWins = function () {
  return gameController.winTask !== undefined;
};

gameController.skip = function () {
  gameController.winSkipped = true;
  if (gameController.winAnimationDelayTimer !== undefined) {
    timerManager.stop(gameController.winAnimationDelayTimer);
    gameController.winAnimationDelayTimer = undefined;
    gameController.winlineAnimsDone();
  }
  gameController.slotMachine.dimAllSymbols(false, 0);
  gameController.winControllerMain.skipAnimations();
  gameController.winlineAnimator.skipAnimation();
};

gameController.skipWin = function () {
  gameController.skip();
  gameController.startNextSpin = true;
};

gameController.freespinsComplete = function (value) {
  gameController.reelsPrize = gameController.preFSReelPrize;
  gameController.featurePrize = value;
  gameController.stateMachine.switchState("IDLE");
};

gameController.onFreespinsStart = function () {
  autoplayManager.stopAutoplay();

  if (gameController.isWildFire) {
    gameController.removeRedSky();
  }
};

gameController.onFreespinsEnd = function () {
  gameController.justHadFreeSpins = true;
  gameController.inFreeSpins = false;
};

gameController.recoverGame = function (task) {
  gameController.wildLandAnimator.skip();
  gameController.redrawSymbols(gameController.slotMachine);

  gameController.gameRecovering = true;

  // Recovery game with encore
  if (
    task.data.metaData === "encore" &&
    gameData.encoreEnabled !== task.data.metaValue
  ) {
    // Clear any encore effects and stop them appearing again
    gameData.encoreEnabled = task.data.metaValue;

    // Put button in the right state if not already true
    var encoreButtonLB = resourceManager.get("goldenBetToggleButton");

    if (encoreButtonLB._flags.showGoldenBetActive !== gameData.encoreEnabled) {
      encoreButtonLB.setRecovery();
    }
  }

  if (
    (task.data.metaData === "buyABonusFireBall" ||
      task.data.metaData === "buyABonusFreeSpins") &&
    task.data.metaValue
  ) {
    let stakeController = resourceManager.getController("stakeController");

    let baseStake = gameData.recoveryStake;

    let stakes = stakeController.Stakes;
    let returnStake = stakes.find((stake) => stake === baseStake);

    if (!returnStake) {
      returnStake = stakes[0];
    }

    stakeController.requestChangeStake(returnStake);
    stakeController.requestChangeStake(baseStake, "FREESPINS_BUY");

    gameData.stakeMeter.set(baseStake);

    gameController.inBuyABonus = true;
    gameController.buyABonusFireball =
      task.data.metaData === "buyABonusFireBall";
    gameController.initNewGame();
    gameController.inBuyABonus = true;
  } else {
    gameController.initNewGame();

    // Update stake
    let stakeController = resourceManager.getController("stakeController");
    // FUTURE REFERENCE - If recovery doesn't have a base stake set make sure you have restorePreviousWagersDerived defined
    let baseStake = stakeController.BaseStake;
    let goldenBetEnabled = gameData.encoreEnabled;

    stakeController.setStakeMultiplier(goldenBetEnabled ? 1.25 : 1);
    gameController.onStakeChanged(baseStake * (goldenBetEnabled ? 1.25 : 1));
    stakeController.broadcastCurrentStake();

    gameController.updatePots(baseStake);
  }
};

gameController.onAbortGame = function () {
  if (gameController.currentReelSpin !== undefined) {
    soundManager.stop(gameController.currentReelSpin);
  }

  gameController.slotMachine.abortSpin();
  Loader.setStartingSymbols();

  gameController.redrawSymbols(gameController.slotMachine);
};

gameController.onOrientationChange = function () {
  if (gameController.redLightningTimeline && gameController.isWildFire) {
    gameController.redLightningTimeline.progress(1);
  }

  if (gameController.reelBackerGlow) {
    gameController.reelBackerGlow.x = gameController.reelBackerGlowPos;
  }
};

gameController.onfireballLinkStartEvent = function () {
  gameController.cancelAutoplay();
  gameController.inFirelink = true;

  if (gameController.isWildFire) {
    gameController.removeRedSky();
  }
};

gameController.onRetriggering = function (task) {
  gameController.retriggerTask = task;
  gameController.retriggerTask.join();

  soundManager.play("BellRing");
  gameController.stateMachine.switchState("RETRIGGER");
};

gameController.onfireballLinkEndEvent = function () {
  gameController.inFirelink = false;
  gameController.justHadFbl = true;
};

gameController.onFireballsLandedEvent = function (task) {
  task.join();

  let count = task.data.fireballs.length;

  task.data.fireballs.forEach(function (fireball) {
    const reel = fireball.coord.reel;
    const row = fireball.coord.row;
    const isFlbFireball = fireball.fblFireball;
    const blueFireball = gameController.isWildFire && !isFlbFireball;

    gameController.reelFireballs[reel][row].animate(
      blueFireball,
      function () {
        task.leave();
      },
      function () {
        count--;
        if (count <= 0) {
          game.thunderAnim.play(0);
          soundManager.play("thunder");
          soundManager.play("lightningPunchQuiet");
        }
      }
    );
  });
};

gameController.onFireballLinkEndEvent = function () {
  gameData.reels.forEach(function (reel) {
    reel.turnFireballsBlue(false);
  });
};

gameController.onEndOfBaseGameSpinEvent = function (task) {
  if (gameController.bigWin.checkBigWin(task.data.totalWin)) {
    task.join();
    gameController.startNextSpin = false;
    gameController.bigWin.start(
      task.data.totalWin,
      function () {
        gameController.nightBackground.visible = false;
        gameController.nightBackgroundPortrait.visible = false;
        task.leave();
      },
      true,
      false,
      function () {},
      false,
      task.data.isCapped
    );
  } else {
    if (gameController.nightBackground.visible) {
      timerManager.addTimer(
        500,
        function (progress) {
          gameController.nightBackground.alpha = 1 - progress;
        },
        function () {
          gameController.nightBackground.alpha = 1;
          gameController.nightBackground.visible = false;
        }
      );
    }
    if (gameController.nightBackgroundPortrait.visible) {
      timerManager.addTimer(
        500,
        function (progress) {
          gameController.nightBackgroundPortrait.alpha = 1 - progress;
        },
        function () {
          gameController.nightBackgroundPortrait.alpha = 1;
          gameController.nightBackgroundPortrait.visible = false;
        }
      );
    }
  }
};

gameController.setCachedStart = function () {
  gameController.cachedStart = true;
  gameController.startNextSpin = true;
  if (gameController.isAnimatingWins()) {
    gameController.shaker.skip();
    gameController.skipWin();
  }
};

gameController.onPotBonusEndEvent = function (task) {
  gameController.preFSReelPrize += task.winAmount;
};

gameController.onModal = function (event) {
  if (event.reason && event.reason !== "") {
    if (event.reason === "Platform Paused") {
      gameController.cancelAutoplay();
      autoplayManager.stopAutoplay();
      gameController.stoppingAutoplay = true;
      gameController.platformPaused = true;
    } else if (event.data && event.data === "Platform Popup Open") {
      gameController.platformPopupActive = true;
    }
  } else if (event.data) {
    if (
      event.data === "Platform Popup Close" &&
      !gameController.platformPaused
    ) {
      gameController.platformPopupActive = false;
    } else if (event.data === "Platform Resume") {
      gameController.platformPaused = false;
    }

    if (gameController.platformPopupActive || gameController.platformPaused) {
      gameController.cancelAutoplay();
      autoplayManager.stopAutoplay();
      gameController.stoppingAutoplay = true;
      messageBus.post("game:modal", {
        reason: "Keep locked",
        data: "Keep locked",
      });
    }
  }
};

Reflex.addToUpdate(gameController.update);
messageBus.subscribe("spinner:SpinEvent", gameController.doSpin);
messageBus.subscribe("autoplay:started", gameController.autoplayStarted);
messageBus.subscribe("autoplay:ended", gameController.autoplayEnded);
messageBus.subscribe("stake:stakeChanged", gameController.onStakeChanged);
messageBus.subscribe("common:RecoverGame", gameController.recoverGame);
messageBus.subscribe("common:GameCompleteEvent", gameController.onGameComplete);
messageBus.subscribe("spinner:WinningLinesEvent", gameController.initPayWins);
messageBus.subscribe("game:modal", gameController.onModal);
messageBus.subscribe(
  "spinner:FreeSpinsStartEvent",
  gameController.onFreespinsStart
);
messageBus.subscribe(
  "spinner:FreeSpinsEndEventDead",
  gameController.onFreespinsEnd
);
messageBus.subscribe("common:AbortGame", gameController.onAbortGame);
messageBus.subscribe(
  "8bof:FireballLinkStartEvent",
  gameController.onfireballLinkStartEvent
);
messageBus.subscribe(
  "8bof:FireballLinkEndEventDead",
  gameController.onfireballLinkEndEvent
);
messageBus.subscribe(
  "8bof:FireballsLandedEvent",
  gameController.onFireballsLandedEvent
);
messageBus.subscribe(
  "8bof:FireballLinkEndEvent",
  gameController.onFireballLinkEndEvent
);
messageBus.subscribe(
  "8bof:EndOfBaseGameSpinEvent",
  gameController.onEndOfBaseGameSpinEvent
);
messageBus.subscribe("8bof:initialRetrigger", gameController.onRetriggering);
messageBus.subscribe(
  "8bof:PotBonusStartEventDead",
  gameController.onPotBonusEndEvent
);
Reflex.registerEventHandler("layoutChange", gameController.onOrientationChange);
